import qs from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';
import { ReportsMenuView } from './ReportsMenu.view';
import { withTheme } from '@emotion/react';
import { MOMENT_DATE } from 'common/constants';
import { RematchContext } from 'models/rematchStore';

const dayWhenDataStarted = moment('2018-04-01');

const mapState = ({ appData }) => ({
    selectedParkData: appData.selectedParkData,
});

const ReportsMenuContainer = ({ ...props }) => {
    const mergeProps = {
        ...props,
        getUrlWithDay: (currentPath, part, selectedDate) => ({
            pathname: `${currentPath}/${part}`, // Uses current URL path
            search: qs.stringify({ day: selectedDate.format(MOMENT_DATE) }),
        }),
        isOutsideRange: (day) => !day.isBefore(moment(), 'day') || day.isBefore(dayWhenDataStarted),
    };

    return <ReportsMenuView {...mergeProps} />;
};

const connected = connect(mapState, undefined, null, { context: RematchContext });

const enhance = compose(withTheme, connected);

export const ReportsMenu = enhance(ReportsMenuContainer);
